import React from 'react';
import image from '../images/logoYa.png'
const Logo = (props) => {
  return <img src={image} alt="Logo" {...props}  width='63px' height='63px' style={{borderRadius:'50%'}}/>;
};

export default Logo;
